import axios from 'axios';
import store from '../store/index.js';

export default function setup() {
    axios.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        if (401 === error.response.status) {
            store.dispatch("setGlobalAlert", {
                alert: true,
                color: "red",
                alertMessage: "You do not have permission to access this content. Please contact your system administrator.",
            })
            return Promise.reject(error)
        } else if (403 === error.response.status) {
            store.commit('logout');
            window.location = '/user-login'
            store.dispatch("setGlobalAlert", {
                alert: true,
                color: "red",
                alertMessage: "Your session has expired, please login again.",
            })
        } else {
            console.error('Error in global interceptor.', error)
            return Promise.reject(error)
        }
    });
}